import repository from "@/repo/repository.service";

export const base = {
  namespaced: true,
  state: {
    baseData: {
      city: [],
      state: [],
    },
  },
  getters: {
    base: (state) => {
      return state.baseData ?? JSON.parse(localStorage.getItem("base"));
    },
  },
  actions: {
    getAllData({ commit }) {
      return new Promise((resolve, reject) => {
        repository
          .postData("/GetBaseData", {
            "api-key": "sJ4D*q#dI4J@as7D1(s$",
          })
          .then((res) => {
            commit("set", res.data);
            resolve(res.data);
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    set(state, baseInfo) {
      Object.assign(state.baseData, baseInfo);
      localStorage.setItem("base", JSON.stringify(state.baseData));
    },
  },
};
